import PropTypes from 'prop-types';
import React from 'react';
import EmailSocialIcon from './social_icons/email';
import FacebookSocialIcon from './social_icons/facebook';
import FlipboardSocialIcon from './social_icons/flipboard';
import PinterestSocialIcon from './social_icons/pinterest';
import SMSSocialIcon from './social_icons/sms';
import TwitterSocialIcon from './social_icons/twitter';
import WhatsappSocialIcon from './social_icons/whatsapp';
import classNames from 'classnames';
import {map, partial} from 'lodash';

const getSocialIconComponent = (icon) => {
  switch (icon) {
    case 'email': return EmailSocialIcon;
    case 'facebook': return FacebookSocialIcon;
    case 'flipboard': return FlipboardSocialIcon;
    case 'pinterest': return PinterestSocialIcon;
    case 'sms': return SMSSocialIcon;
    case 'twitter': return TwitterSocialIcon;
    case 'whatsapp': return WhatsappSocialIcon;
    default: return null;
  }
};

const buildSocialIcon = (props, icon) => {
  const iconComponent = getSocialIconComponent(icon);
  if (!iconComponent) {
    return null;
  }

  return React.createElement(iconComponent, {
    key: icon,
    ...props
  });
};

const SocialIcons = ({
  icons,
  ...props
}) => (
  <div className={classNames('story-share', props.className)}>
    {
      map(
        icons,
        partial(buildSocialIcon, props)
      )
    }
  </div>
);

SocialIcons.propTypes = {
  className: PropTypes.string,
  icons: PropTypes.arrayOf(
    PropTypes.string.isRequired
  ).isRequired
};

export default SocialIcons;
